import { Image as ExpoImage } from 'expo-image';
import { Key } from 'react';
import Animated from 'react-native-reanimated';
import { GetProps, styled } from 'tamagui';

export type ImageProps = GetProps<typeof Image>;
export type AnimatedImageProps = Omit<GetProps<typeof AnimatedImage>, 'key'> & {
  key?: Key;
};

/**
 * Styled Expo Image component.
 */
export const Image = styled(ExpoImage, {
  name: 'Image',

  variants: {
    rounded: {
      true: {
        borderRadius: '$10'
      }
    },

    size: {
      '...size': (val, { tokens }) => {
        const size = tokens.size[val as keyof typeof tokens.size];
        return {
          w: size,
          h: size
        };
      },
      ':number': (val: number) => ({
        w: val,
        h: val
      })
    }
  } as const,

  defaultVariants: {
    size: '$1.5',
    rounded: false
  }
});

export const AnimatedImage = Animated.createAnimatedComponent(Image);
